import { Map } from 'immutable';

import { BILLING_FEATURE_TO_PLAN, BILLING_FEATURES, PLAN, TIER_LIMITS, TIER_PRICE, TIER_PRICE_DISCOUNTED } from '../constants/billingV3';
import { TIER as LEGACY_TIER } from '../constants/billing';
import { STATUSES } from '../constants/shops';
import { EMPTY } from '../constants';

export function isBillingError({ plan, syncStatus }) {
  switch (syncStatus) {
    case STATUSES.REIMPORT_SHOP:
    case STATUSES.TOKEN_REJECTED: {
      return false;
    }

    default: {
      break;
    }
  }

  return plan === PLAN.ERROR;
}

export function isUnpaid(subscription = EMPTY.MAP) {
  switch (subscription.get('plan')) {
    case PLAN.FREE: {
      return false;
    }

    case PLAN.TRIAL: {
      return (subscription.get('trialRemaining') || 0) < 1;
    }

    default: {
      return (
        subscription.get('tierChangeDetected') || (
          !subscription.get('subscriptionId') &&
          !subscription.get('frozen')
        )
      );
    }
  }
}

export function isSubscribed(subscription = EMPTY.MAP) {
  return !!subscription.get('subscriptionId') && !subscription.get('cancelAtPeriodEnd');
}

export function getTier({ listings }) {
  for (const [tier, limits] of Object.entries(TIER_LIMITS)) {
    const [from, to] = limits;

    if (listings >= from && listings <= to) {
      return tier;
    }
  }
}

export function getBillingPrice({ discount, plan, tier }) {
  return discount
    ? TIER_PRICE_DISCOUNTED[plan][tier]
    : TIER_PRICE[plan][tier];
}

export function shapeQuoteForApp(response) {
  function shapeQuote(plan, quote) {
    const {
      discount_percent: discount,
      product_count: listings,
    } = quote;

    const tier = getTier({ listings });
    const price = getBillingPrice({ discount, plan, tier });
    const undiscountedPrice = discount > 0
      ? getBillingPrice({ plan, tier })
      : 0;

    return Map({
      discount,
      listings,
      plan,
      price,
      tier,
      undiscountedPrice,
    });
  }

  return Map({
    [PLAN.LITE]: shapeQuote(PLAN.LITE, response.lite),
    [PLAN.PLUS]: shapeQuote(PLAN.PLUS, response.plus),
  });
}

export function isVIPPlan(plan) {
  if (!plan) return false;

  switch (plan.split('.')[0]) {
    case LEGACY_TIER.T_0:
    case LEGACY_TIER.T_251:
    case LEGACY_TIER.T_501:
    case LEGACY_TIER.T_1001:
    case LEGACY_TIER.T_2501:
    case LEGACY_TIER.T_5001:
    case LEGACY_TIER.T_7501:
    case LEGACY_TIER.T_10001:
    case LEGACY_TIER.T_20001:
    case LEGACY_TIER.T_30001:
    case LEGACY_TIER.T_40001:
    case LEGACY_TIER.T_50001:
    case LEGACY_TIER.T_60001:
    case LEGACY_TIER.T_70001: {
      return true;
    }

    default: {
      return false;
    }
  }
}

export function isPlusPlan(plan) {
  if (!plan) return false;

  switch (plan.split('.')[0]) {
    case PLAN.PLUS:
    case PLAN.TRIAL: {
      return true;
    }

    default: {
      return isVIPPlan(plan);
    }
  }
}

export function isFeatureEnabledForPlan({ feature, plan = '', ...rest }) {
  switch (plan.split('.')[0]) {
    case PLAN.FREE:
    case PLAN.TRIAL: {
      return true;
    }

    case PLAN.LITE: {
      switch (feature) {
        case BILLING_FEATURES.PROFILES_STANDARD_PROFILES: {
          return BILLING_FEATURE_TO_PLAN[feature][PLAN.LITE] > rest.count;
        }

        default: {
          return !!BILLING_FEATURE_TO_PLAN[feature]?.[PLAN.LITE];
        }
      }
    }

    case PLAN.PLUS: {
      switch (feature) {
        case BILLING_FEATURES.PROFILES_STANDARD_PROFILES: {
          return true;
        }

        default: {
          return !!BILLING_FEATURE_TO_PLAN[feature]?.[PLAN.PLUS];
        }
      }
    }

    default: {
      return isVIPPlan(plan);
    }
  }
}
